import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { TranslocoDirective } from '@jsverse/transloco';
import { SignableEformComponent } from './signable-eform.component';


const routes: Routes = [
  {
    path: '',
    component: SignableEformComponent,
    data: { animation: 'zoomIn' },
  },
];


@NgModule({ 
  declarations: [

  ],
  imports: [
    RouterModule.forChild(routes),
    NgbModule,
    CoreCommonModule,
    NgSelectModule,
    FormsModule,
    SharedModule,
    TranslocoDirective
  ],
  exports: [

  ]
})
export class SignAbleEformsModule {}
